export default "__VITE_ASSET__5f59e60d__"